import { ErrorAlert } from '@e2m-customer-portal/ui';
import { Box, Button, CircularProgress, Grid } from '@mui/material';
import { MouseEventHandler, ReactElement } from 'react';

interface DrawerButtonsProps {
  isLoading?: boolean;
  disableSave?: boolean;
  onCancel?: MouseEventHandler<HTMLButtonElement>;
  onSave?: MouseEventHandler<HTMLButtonElement>;
  cancelLabel: string;
  saveLabel: string;
  error?: Error | string;
}

/**
 * DrawerButtons can be added to the DrawerFooter including a cancel and a save button.
 */
export function DrawerButtons({
  isLoading,
  disableSave,
  onCancel,
  onSave,
  cancelLabel,
  saveLabel,
  error,
}: Readonly<DrawerButtonsProps>): ReactElement<DrawerButtonsProps> {
  return (
    <>
      {error && (
        <Box sx={{ marginBottom: 2 }}>
          <ErrorAlert error={error} />
        </Box>
      )}
      <Grid container spacing={1}>
        <Grid sx={{ textAlign: 'left' }} item xs={6}>
          <Button variant="outlined" color="primary" onClick={onCancel}>
            {cancelLabel}
          </Button>
        </Grid>

        <Grid sx={{ textAlign: 'right' }} item xs={6}>
          <Button
            color="primary"
            onClick={onSave}
            disabled={disableSave}
            startIcon={isLoading && <CircularProgress size="1rem" />}
          >
            {saveLabel}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
